<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formDatas.iuId" placeholder="请选择面试官" size="small" style="width: 140px" clearable
                        @change="partserch">
                        <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName"
                            :value="item.iuId" :key="item.iuId"
                            :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.ijcId" placeholder="请选择招聘渠道" size="small" style="width: 140px"
                        clearable>
                        <el-option v-for="(item, index) in getIvJobChannelList_data || []" :label="item.ijcName"
                            :value="item.ijcId" :key="item.ijcId"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.ijawName" style="width: 140px;" size="small " placeholder="请输入人才名称"
                        clearable></el-input>
                    <el-input v-model="formDatas.ijawPhone" style="width: 140px;" size="small " placeholder="请输入联系电话"
                        clearable></el-input>
                    <el-input v-model="formDatas.ijawEducationLevel" style="width: 140px;" size="small "
                        placeholder="请输入学历" clearable></el-input>
                    <el-select size="small" v-model="formDatas.ijawSex" clearable @change="partserch"
                        placeholder="请选择性别" style="width: 130px">
                        <el-option label="男" value="男" key="2"></el-option>
                        <el-option label="女" value="女" key="1"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.ijawResignationInitiated" clearable @change="partserch"
                        placeholder="是否已提离职" style="width: 130px">
                        <el-option label="是" value="是" key="2"></el-option>
                        <el-option label="否" value="否" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="businessOpportunitiesClicks()">转商机申请</el-button> -->
                    <el-button type="primary" size="small" style="margin-left: 10px;"
                        @click="BatchBelonging">批量修改归属</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新建人才</el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ijawId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit ? '编辑人才' : '新增人才'" :visible.sync="dialog" width="70%" top="8vh">
                <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:65vh">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="招聘渠道" prop="ijcId">
                            <el-select v-model="form.ijcId" placeholder="请选择">
                                <el-option v-for="(item, index) in getIvJobChannelList_data || []" :label="item.ijcName"
                                    :value="item.ijcId" :key="item.ijcId"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="人才名称" prop="ijawName">
                            <el-input v-model="form.ijawName" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="ijawPhone">
                            <el-input v-model="form.ijawPhone" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="性别" prop="ijawSex">
                            <el-radio-group v-model="form.ijawSex">
                                <el-radio label="男">男</el-radio>
                                <el-radio label="女">女</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="年龄" prop="ijawAge">
                            <el-input v-model="form.ijawAge" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="学历" prop="ijawEducationLevel">
                            <el-select v-model="education" placeholder="请选择">
                                <el-option label="全日制" value="全日制" :key="1"> </el-option>
                                <el-option label="非全日制" value="非全日制" :key="2">
                                </el-option>
                            </el-select>
                            <el-select v-model="form.ijawEducationLevel" placeholder="请选择">
                                <el-option label="博士研究生" value="博士研究生" :key="2">
                                </el-option>
                                <el-option label="硕士研究生" value="硕士研究生" :key="3">
                                </el-option>
                                <el-option label="本科" value="本科" :key="4"> </el-option>
                                <el-option label="专科" value="专科" :key="1"> </el-option>
                                <el-option label="其他" value="其他" :key="5"> </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="现工作单位" prop="ijawUnitNow">
                            <el-input v-model="form.ijawUnitNow" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="接触过的行业" prop="ijawIndustryDes">
                            <el-input v-model="form.ijawIndustryDes" style="width: 50%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="是否已提离职" prop="ijawResignationInitiated">
                            <el-radio-group v-model="form.ijawResignationInitiated">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="大概离职日期" prop="ijawResignationDate">
                            <el-date-picker v-model="form.ijawResignationDate" type="date" value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="目前动摇原因" prop="ijawResignationReason">
                            <el-input v-model="form.ijawResignationReason" type="textarea" style="width: 50%;"
                                placeholder="请输入"></el-input>
                        </el-form-item>

                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑简历 -->
            <el-dialog title="编辑简历" :visible.sync="JLdialog" width="70%" top="8vh">
                <el-form ref="formJL" :model="formJL" label-position="top" :rules="rules" style="height: 65vh">
                    <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
                        <el-form-item label="简历地址" prop="ijawBiographicalNotes">
                            <my-uploads ref="JLOtherImgupload" @fileChange="JLOtherImgChange"
                                :filearr="JLOtherImgfileList" :limit="1" style="margin: 10px 5px 5px" type="text">
                            </my-uploads>
                            <el-input disabled v-model="formJL.ijawBiographicalNotes" style="width: 50%"
                                placeholder="请输入"></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="JLhandleClose">取 消</el-button>
                    <el-button type="primary" @click="JLSureBtn">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑归属 -->
            <el-dialog title="编辑归属" :visible.sync="BelongDialog" width="70%" top="8vh" :before-close="belongHandleClose">
                <el-form ref="formBelong" :model="formBelong" label-position="top" :rules="rules" style="height: 65vh">
                    <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
                        <el-form-item label="归属" prop="iuId">
                            <el-select v-model="formBelong.iuId" placeholder="请选择">
                                <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName"
                                    :value="item.iuId" :key="item.iuId"
                                    :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="belongHandleClose">取 消</el-button>
                    <el-button type="primary" @click="belongSureBtn">确 定</el-button>
                </span>
            </el-dialog>
        </div>

    </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import {
    addIvJobApplicantWare, deleteIvJobApplicantWare, getIvJobChannelList, updateIvJobApplicantWare, getIvJobApplicantWareList,
    updateIvJobApplicantWareBiographicalNotes, getIvUserList, updateIvJobApplicantWareBelong,

} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            getIvUserList_data: [],
            BelongDialog: false,
            formBelong: {},

            JLdialog: false,
            formJL: {

            },
            JLOtherImgfileList: [],
            education: '',
            getIvJobChannelList_data: [],
            postForm: {

            },
            userarr: [],
            level_Four: [],
            level_Three: [],
            key: 'ijawId',
            dialog: false,
            edit: false,
            form: {
                ijcId: '',
                ijawName: '',
                ijawPhone: '',
                ijawSex: '',
                ijawAge: '',
                ijawEducationLevel: '',
                ijawUnitNow: '',
                ijawIndustryDes: '',
                ijawBiographicalNotes: '',
                ijawResignationInitiated: '',
                ijawResignationDate: '',
                ijawResignationReason: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ijcName",
                    key: "ijcName",
                    title: "招聘渠道",
                    width: 110,
                    align: "center",
                    edit: false,
                    fixed: 'left',
                },
                {
                    field: "ijawName",
                    key: "ijawName",
                    fixed: 'left',
                    title: "人才名称",
                    width: 90,
                    align: "center",
                    fixed: 'left',
                    // edit: true,
                },
                {
                    field: "iuName",
                    key: "iuName",
                    title: "面试官",
                    width: 90,
                    align: "center",
                    edit: false,
                    fixed: 'left',
                },
                {
                    field: "ijawPhone",
                    key: "ijawPhone",
                    title: "联系电话",
                    width: 110,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawSex",
                    key: "ijawSex",
                    title: "性别",
                    width: 70,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawAge",
                    key: "ijawAge",
                    title: "年龄",
                    width: 70,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawEducationLevel",
                    key: "ijawEducationLevel",
                    title: "学历",
                    width: 100,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawUnitNow",
                    key: "ijawUnitNow",
                    title: "现工作单位",
                    width: 200,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawIndustryDes",
                    key: "ijawIndustryDes",
                    title: "接触过的行业",
                    width: 200,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawBiographicalNotes",
                    key: "ijawBiographicalNotes",
                    title: "简历",
                    width: 120,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {row.ijawBiographicalNotes ? (
                                    <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() =>
                                            window.open(
                                                `https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(
                                                    Base64.encode(row.ijawBiographicalNotes)
                                                )}`
                                            )
                                        }
                                    >
                                        预览
                                    </el-button>
                                ) : (
                                    ""
                                )}
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.updataJl(row.ijawId)}
                                >
                                    编辑
                                </el-button>
                            </span>
                        );
                    },
                },
                {
                    field: "ijawResignationInitiated",
                    key: "ijawResignationInitiated",
                    title: "是否已提离职",
                    width: 70,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawResignationDate",
                    key: "ijawResignationDate",
                    title: "大概离职日期",
                    width: 150,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawResignationReason",
                    key: "ijawResignationReason",
                    title: "目前动摇原因",
                    width: 750,
                    align: "center",
                    // edit: true,
                },
                {
                    field: "ijawDateInterview",
                    key: "ijawDateInterview",
                    title: "面试日期",
                    width: 90,
                    align: "center",
                    edit: false,
                },
                {
                    field: "ijawTimeInterview",
                    key: "ijawTimeInterview",
                    title: "面试时间",
                    width: 60,
                    align: "center",
                    edit: false,
                },
                { field: "createusername", key: "createusername", title: "创建人", width: 160, align: "center" },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 250,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    this.postid == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleBelong(row)}
                                    >
                                        归属
                                    </el-button> : ''
                                }
                                {
                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button>
                                }
                                {

                                    <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button>
                                }




                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                ijcId: "",
                ijawName: "",
                ijawPhone: "",
                ijawSex: "",
                ijawEducationLevel: "",
                ijawResignationInitiated: "",
                currentPage: 1,
                pageSize: 10,
            },
            postid: "",
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.postid = localStorage.getItem("iuPost");
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        this.getPost('industry')
        getIvJobChannelList().then((res) => {
            this.getIvJobChannelList_data = res.data;
        });
        getIvUserList({ iuJoinInterview: 2 }).then((res) => {
            this.getIvUserList_data = res.data;

        });

    },
    mounted() { },
    methods: {
        BatchBelonging() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: "danger",
                });
            } else {
                this.formBelong.ijawIds = this.selectedRowKeysCollection.toString(),
                this.BelongDialog = true;
            }

        },
        belongHandleClose() {
            this.BelongDialog = false;
            this.$refs['formBelong'].resetFields();
            this.checkboxOption.selectedRowKeys = [];
            this.selectedRowKeysCollection= []
        },
        belongSureBtn() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateIvJobApplicantWareBelong(this.formBelong).then((res) => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.belongHandleClose();
                            this.getList();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        handleBelong(row) {
            this.formBelong.ijawIds = row.ijawId
            this.BelongDialog = true;

        },
        updataJl(id) {
            this.formJL.ijawId = id;
            this.JLdialog = true;
        },
        JLhandleClose() {
            this.JLdialog = false;
            this.formJL = {};
            setTimeout(() => {
                this.$refs.JLOtherImgupload.fileAllRemove();
                this.JLOtherImgfileList = [];
            }, 10);
        },
        JLSureBtn() {
            this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateIvJobApplicantWareBiographicalNotes(this.formJL).then((res) => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.JLhandleClose();
                            this.getList();
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        JLOtherImgChange(file) {
            if (file.length > 1) {
                this.audioFIle = file;
            } else {
                this.audioFIle = file;
                this.$set(this.formJL, "ijawBiographicalNotes", file[0].fileurl);
                this.$message({
                    type: "success",
                    message: "上传成功!",
                });
            }
        },
        getPost(key) {
            const userpost = JSON.parse(sessionStorage.getItem('userPost')) || [];
            userpost.forEach((item, index) => {
                if (item.nsaMenuKey == key) {
                    this.postForm[item.nsaFuncKey] = item.nsaFuncLabel
                }
            })
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteIvJobApplicantWare({ ijawId: row.ijawId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
                const arr = data.ijawEducationLevel.split(" ");
                if (arr.length <= 1) {
                    if (arr[0].indexOf("全日制", 0) == -1) {
                        this.education = "全日制";
                        this.form.ijawEducationLevel = arr[0];
                    } else {
                        if (arr[0].indexOf("非全日制", 0) > -1) {
                            this.education = arr[0].substring(
                                arr[0].indexOf("非全日制", 0),
                                arr[0].indexOf("非全日制", 0) + 4
                            );
                            this.form.ijawEducationLevel = arr[0].substring(
                                arr[0].indexOf("非全日制", 0) + 4,
                                arr[0].length
                            );
                        } else {
                            this.education = arr[0].substring(
                                arr[0].indexOf("全日制", 0),
                                arr[0].indexOf("全日制", 0) + 3
                            );
                            this.form.ijawEducationLevel = arr[0].substring(
                                arr[0].indexOf("全日制", 0) + 3,
                                arr[0].length
                            );
                        }
                    }
                } else {
                    this.education = arr[0] ? arr[0] : "";
                    this.form.ijawEducationLevel = arr[1] ? arr[1] : "";
                }
            });
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.ijawEducationLevel = this.form.ijawEducationLevel
                            ? this.education + " " + this.form.ijawEducationLevel
                            : "";
                        addIvJobApplicantWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.form.ijawEducationLevel = this.form.ijawEducationLevel
                            ? this.education + " " + this.form.ijawEducationLevel
                            : "";
                        updateIvJobApplicantWare(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ijawId = row.ijawId
                    //console.log(jsonObj);
                    updateIvJobApplicantWare(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                //console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // //console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        //console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(index, 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            //console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getIvJobApplicantWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getIvJobApplicantWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getIvJobApplicantWareList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>